var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex p-6 radius-4 gap-6",class:[
    _vm.activeTheme.bgClass,
    _vm.activeTheme.textClass,
    _vm.activeTheme.borderClass,
    `align-items-${_vm.position}`
  ]},[(_vm.activeTheme.icon && _vm.showIcon)?_c(_vm.activeTheme.icon,{tag:"component",staticClass:"flex-shrink-0",attrs:{"color":_vm.activeTheme.iconColor}}):_vm._e(),_vm._t("default",function(){return [_c('p',{staticClass:"p-base-light"},[_vm._v(" "+_vm._s(_vm.content)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }